export enum Treatment {
  OFF = "off",
  ON = "on",
  PENDING = "pending",
}

// As of this moment, we do not pass custom treatments.
// Treatments should always be either 'on' or 'off'
export const parseTreatment = (treatment: string): Treatment => {
  if (treatment === "on") {
    return Treatment.ON;
  }
  return Treatment.OFF;
};
